import React from 'react'

import type { IconProps } from './types'

const GPS: React.FC<IconProps> = ({
  size = 20,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" {...rest}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2565 8.45986H17.4601C17.7554 8.45986 17.9953 8.69701 18 8.99105V9.00869C17.9953 9.30289 17.7554 9.53988 17.4601 9.53988H16.2565C15.9859 13.1346 13.129 15.9918 9.53428 16.2626V17.4601C9.53428 17.7554 9.29729 17.9953 9.00325 18H8.98561C8.69142 17.9953 8.45442 17.7554 8.45442 17.4601V16.2626C4.85991 15.9916 2.00299 13.1344 1.73241 9.53988H0.540009C0.241743 9.53988 0 9.29814 0 8.99987C0 8.70177 0.241743 8.45986 0.540009 8.45986H1.73241C2.00299 4.86535 4.85991 2.0081 8.45459 1.73719V0.540009C8.45459 0.241743 8.69633 0 8.9946 0C9.2927 0 9.53461 0.241743 9.53461 0.540009V1.73719C13.1291 2.0081 15.9859 4.86535 16.2565 8.45986ZM2.78507 8.99971C2.78507 12.4291 5.56504 15.2094 8.99443 15.2096C12.4225 15.2058 15.2005 12.4279 15.2046 8.99987C15.2046 5.57048 12.4245 2.79018 8.99493 2.79018C5.56553 2.79018 2.78524 5.57015 2.78507 8.99971ZM8.99443 12.5998C10.9826 12.5998 12.5944 10.988 12.5944 8.99987C12.5944 7.01171 10.9826 5.40009 8.99443 5.40009C7.00627 5.40009 5.39465 7.01171 5.39465 8.99987C5.39465 10.988 7.00627 12.5998 8.99443 12.5998Z"
        fill={color}
      />
    </svg>
  )
}

export default GPS
